<template>
  <div
    class="d-flex"
    :class="{
      'justify-space-between': showBackButton && showNextButton,
      'justify-end': !showBackButton && showNextButton,
      'justify-start': showBackButton && !showNextButton,
    }"
  >
    <Button
      v-if="showBackButton"
      plain
      class="mr-6"
      color="blueGrey"
      data-testid="phasesNavigateButtons-button-back"
      icon="mdi-chevron-left"
      :text="$t('common.button.back')"
      @click="$emit('back')"
    />
    <Button
      v-if="showNextButton"
      plain
      color="primary"
      data-testid="phasesNavigateButtons-button-next"
      icon="mdi-chevron-right"
      iconPosition="right"
      :text="$t('common.button.next')"
      @click="$emit('next')"
    />
  </div>
</template>

<script>
import Button from '@/components/UI/Button.vue'

export default {
  props: {
    showNextButton: Boolean,
    showBackButton: Boolean,
  },
  components: {
    Button,
  },
}
</script>
